//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name:'',
  data() {
    return {
      
    }
  },
  created() { 
  },
  methods: {
    goBw(){
      this.STATISTICS('click','sybao_ins_game_banner_click');
      this.$router.push({
        path: "/safeguard",
        query: {
          templateFlag:'tk_mil',
          from_action:'game'
        }
      })
    }
  }
}
